function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M12.0893 0L18.3402 0.67425L23.1797 7.30184L12.0893 20.4769L0.998837 7.30175L5.83825 0.67425L12.0893 0Z",
  fill: "#FDB300"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M23.1797 7.30273L12.0893 20.4778L18.6875 7.30273H23.1797Z",
  fill: "#EB6C00"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M5.49165 7.30273L12.0898 20.4778L0.999418 7.30273H5.49165Z",
  fill: "#EB6C00"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M18.6875 7.30273L12.0892 20.4778L5.49093 7.30273H18.6875Z",
  fill: "#FDAD00"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M18.3401 0.67425L18.6875 7.30184L12.0891 0L18.3401 0.67425Z",
  fill: "#FDD231"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "M5.49165 7.30184L5.83891 0.67425L12.0898 0L5.49165 7.30184Z",
  fill: "#FDD231"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  d: "M5.49648 7.30142H1.00434L5.84375 0.673828L5.49648 7.30142Z",
  fill: "#FDAD00"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  d: "M23.1797 7.30142H18.6875L18.3402 0.673828L23.1797 7.30142Z",
  fill: "#FDAD00"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  d: "M12.0892 0L18.6875 7.30175H5.49093L12.0892 0Z",
  fill: "#FEEEB7"
});

var SvgSketch = function SvgSketch(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 24,
    height: 21,
    viewBox: "0 0 24 21",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSketch, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/sketch.9b28d5df.svg";
export { ForwardRef as ReactComponent };